/**
 * Processo da encomenda: os passos acendem por ordem e a linha avança com eles.
 *
 * Só arranca quando a secção entra no ecrã. A correr desde o carregamento da
 * página, já teria dado a volta antes de alguém chegar lá abaixo — e ficaria a
 * gastar tempo do navegador enquanto ninguém a vê.
 *
 * O rato manda: apontar um passo salta logo para ele, e a partir daí a
 * sequência continua desse ponto em vez de voltar ao princípio.
 */
class ClaroPassos extends HTMLElement {
  #passos = [];
  #indice = 0;
  #relogio = null;
  #observador = null;
  #aVista = false;

  connectedCallback() {
    this.#passos = [...this.querySelectorAll('[data-passo]')];
    if (this.#passos.length < 2) return;

    // Quem pediu menos movimento fica com os três acesos, sem sequência
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.style.setProperty('--avanco', '100%');
      return;
    }

    this.#passos.forEach((passo, i) => {
      // `pointerenter` e não `mouseenter`: apanha o rato e a caneta, e não
      // dispara ao arrastar o dedo por cima num telemóvel
      passo.addEventListener('pointerenter', (evento) => {
        if (evento.pointerType === 'touch') return;
        this.#salta(i);
      });

      // No telemóvel não há rato a passar por cima: toca-se
      passo.addEventListener('click', () => this.#salta(i));
    });

    this.#observador = new IntersectionObserver(
      ([entrada]) => {
        this.#aVista = entrada.isIntersecting;
        this.#aVista ? this.#arranca() : this.#para();
      },
      { threshold: 0.4 }
    );
    this.#observador.observe(this);
  }

  disconnectedCallback() {
    this.#para();
    this.#observador?.disconnect();
  }

  /** Vai para um passo e reconta o tempo a partir dele */
  #salta(indice) {
    if (indice === this.#indice) return;
    this.#mostra(indice);
    if (this.#aVista) {
      this.#para();
      this.#arranca(false);
    }
  }

  #arranca(doPrincipio = true) {
    if (this.#relogio) return;
    const espera = Number(this.dataset.espera) || 3000;
    if (doPrincipio) this.#mostra(0);
    this.#relogio = setInterval(
      () => this.#mostra((this.#indice + 1) % this.#passos.length),
      espera
    );
  }

  #para() {
    clearInterval(this.#relogio);
    this.#relogio = null;
  }

  #mostra(indice) {
    this.#indice = indice;
    this.#passos.forEach((passo, i) => passo.classList.toggle('claro-passo--on', i === indice));

    // A barra e o ponto leem a mesma percentagem: o último passo enche a linha
    const avanco = (indice / (this.#passos.length - 1)) * 100;
    this.style.setProperty('--avanco', `${avanco}%`);
  }
}

if (!customElements.get('claro-passos')) customElements.define('claro-passos', ClaroPassos);
